<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="http://manyconvert.com/"
        target="_blank"
      >ManyConvert</b-link>
      <span class="d-none d-sm-inline-block">, Todos os direitos reservados.</span>
    </span>

    <span class="float-md-right d-none d-md-block">Feito com
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current m-0"
      />
      na ilha da magia - Florianópolis/SC
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
